import { render } from "./PlayerForecast.vue?vue&type=template&id=98de3b4a&scoped=true"
import script from "./PlayerForecast.vue?vue&type=script&lang=js"
export * from "./PlayerForecast.vue?vue&type=script&lang=js"

import "./PlayerForecast.vue?vue&type=style&index=0&id=98de3b4a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98de3b4a"]])

export default __exports__